import * as ContactActions from "./contact.actions";
import { createReducer, on } from "@ngrx/store";
import { recursive as mergeRecursive } from "merge";
import { ContactState } from "./contact.state";

const initialState: ContactState = {
    currentContact: null,
};

export const ContactReducer = createReducer(
    initialState,
    on(ContactActions.ExtendStateAction, (state, { newState }) => ({ ...state, ...newState })),
    on(ContactActions.MergeStateAction, (state, { newState }) => mergeRecursive(true, state, newState)),
);
